<template>
    <Menu as="div" class="relative -ml-px inline-flex">
        <MenuButton
            type="button"
            class="relative inline-flex items-center bg-white/90 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 backdrop-blur hover:bg-white focus:z-10 disabled:cursor-not-allowed disabled:opacity-60"
            :disabled="disabled || isUpdating"
        >
            <font-awesome-icon :icon="faChevronDown" class="text-gray-900" aria-hidden="true" />
            <span class="ml-2">Status</span>
        </MenuButton>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems class="absolute right-0 z-50 mt-2 w-64 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none">
                <template v-if="!property.deleted_at">
                    <MenuItem
                        v-for="option in options"
                        :key="option.value"
                        v-slot="{ active }"
                    >
                        <button
                            type="button"
                            class="block w-full px-4 py-2 text-left text-sm"
                            :class="[
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                option.value === currentValue ? 'font-semibold text-rent-risk-blue-400' : '',
                            ]"
                            :disabled="disabled || isUpdating"
                            @click="selectStatus(option.value)"
                        >
                            {{ option.label }}
                        </button>
                    </MenuItem>
                </template>

                <div
                    v-if="!property.deleted_at && (showArchiveAction || showRestoreAction)"
                    class="my-1 border-t border-gray-100"
                />

                <MenuItem v-if="showArchiveAction" v-slot="{ active }">
                    <button
                        type="button"
                        class="block w-full px-4 py-2 text-left text-sm text-gray-700"
                        :class="active ? 'bg-gray-100 text-gray-900' : ''"
                        :disabled="disabled || isUpdating"
                        @click="emit('archive')"
                    >
                        Archive
                    </button>
                </MenuItem>

                <MenuItem v-if="showRestoreAction" v-slot="{ active }">
                    <button
                        type="button"
                        class="block w-full px-4 py-2 text-left text-sm text-gray-700"
                        :class="active ? 'bg-gray-100 text-gray-900' : ''"
                        :disabled="disabled || isUpdating"
                        @click="emit('restore')"
                    >
                        Restore
                    </button>
                </MenuItem>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script setup>
import { computed } from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'

const props = defineProps({
    property: {
        type: Object,
        required: true,
    },
    options: {
        type: Array,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    isUpdating: {
        type: Boolean,
        default: false,
    },
    showArchiveAction: {
        type: Boolean,
        default: false,
    },
    showRestoreAction: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['select', 'archive', 'restore'])

const currentValue = computed(() => props.property.lifecycle_status?.value ?? null)

const selectStatus = (value) => {
    if (value === currentValue.value) {
        return
    }

    emit('select', value)
}
</script>
